import React from "react";
import PropTypes from "prop-types";
import { Grid2, Skeleton } from "@mui/material";
// styles
import styles from "./EnvironmentBox.module.scss";

export default function EnvironmentBox(props) {
  const {
    Icon,
    label,
    shortLabel,
    flexDirection,
    onClick,
    width,
    status,
    color,
    border,
    userDetails,
  } = props;
  const dynamicClass = label.replace(/\s+/g, "");

  return (
    <>
      {status ? (
        <Skeleton
          variant="rectangular"
          width={120}
          height={42}
          sx={{
            backgroundColor:
              userDetails === "dark" ? "#f0f0f0" : "rgba(0,0,0,0.11)",
          }}
        />
      ) : (
        <Grid2
          className={`${styles.Box} ${styles[dynamicClass]} ${
            color ? styles.color : ""
          }`}
          onClick={onClick}
          style={{
            flexDirection: flexDirection || "column",
            width: width,
            borderRadius: border,
          }}
        >
          <Icon className={`${styles.icon} ${color ? styles.color : ""}`} />
          <Grid2 className={`${styles.devEnv} ${color ? styles.color : ""}`}>
            <span className={styles.fullLabel}>{label}</span>
            <span className={styles.shortLabel}>{shortLabel}</span>
          </Grid2>
        </Grid2>
      )}
    </>
  );
}

EnvironmentBox.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  shortLabel: PropTypes.string.isRequired,
  flexDirection: PropTypes.oneOf(["row", "column"]),
};
